Wee.fn.make('controllers', {
	init: function() {
		var controllers = Wee.$get('controllers');

		if (controllers != null && controllers.length) {
			controllers.forEach(function(val) {
				Wee[val].init();
			});
		}
	}
});